import * as Yup from 'yup';

export const schemaConstructor = (y: typeof Yup) =>
  y
    .object({
      type: y.string().oneOf(['bug-report', 'suggestion']).required(),
      message: y.string().required().max(500),
    })
    .required();

export type ISchema = Yup.InferType<ReturnType<typeof schemaConstructor>>;
